<div class="checkbox-field" [class.disabled]="disabled">
  <div
    class="checkbox"
    tabindex="0"
    [attr.role]="radio ? 'radio' : 'checkbox'"
    [attr.aria-checked]="ariaChecked"
    [attr.aria-disabled]="disabled ? true : null"
    [attr.aria-invalid]="destructive ? true : null"
    [attr.aria-label]="ariaLabel || null"
    [attr.aria-labelledby]="labelledBy"
    [attr.aria-describedby]="describedBy"
    [ngClass]="{ disabled: disabled, destructive: destructive, radio: radio, filled: isFilled(), 'has-content': hasContent() }"
    (keydown)="onKeydown($event)"
    (click)="setCheck()">
    @if (showTick()) {
      <img [src]="checkedImg" class="check-img" aria-hidden="true" [ngClass]="{ disabled: disabled }" />
    }
    @if (showMinus()) {
      <img [src]="indeterminateImg" class="check-img" aria-hidden="true" [ngClass]="{ disabled: disabled }" />
    }
    @if (radio) {
      <span class="radio-dot" aria-hidden="true" [ngStyle]="{ 'background-color': getDotColor() }"></span>
    }
  </div>

  @if (label || helperText) {
    <div class="checkbox-field__content">
      @if (label) {
        <span [id]="labelId" class="checkbox-field__label" agText="body-3-medium" (click)="setCheck()">{{ label }}</span>
      }
      @if (helperText) {
        <flow-helper-text [id]="helperId" [helperText]="helperText" [variant]="destructive ? 'destructive' : 'default'"></flow-helper-text>
      }
    </div>
  }
</div>
